import React, { Component } from 'react'

export default class extends Component {
  constructor(props) {
    super(props)
  }
  state = {
    time: 0
  }
  async componentWillMount() {
    await this.RunOnStart()
  }

  async RunOnStart() {
  }

  componentWillReceiveProps(e) {
    console.log('componentWillReceiveProps')
    if (this.state.time == 0) {
      let { leftTimestamp } = e
      this.countDown(leftTimestamp)
    }
  }
  countDown = (times) => {
    let { lang } = this.props
    var timer = null
    timer = setInterval(
      function () {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        let daystr = ''
        if (day > 0) {
          // daystr = day
          daystr = day + lang.dayText
        }
        this.setState({
          time: daystr + hour + ':' + minute + ':' + second
        })
        times--
      }.bind(this),
      1000
    )
    if (times <= 0) {
      clearInterval(timer)
    }
  }
  render() {

    let { lang } = this.props

    return (
      <div className="countdown">
        <div className="countdowntitle">
          <img className="left" src="/img/activity/recharge/right.png" />
          <div className="word">{lang.monthly}</div>
          <img className="right" src="/img/activity/recharge/left.png" />
        </div>
        <div className="timer">
          {lang.timeR} {this.state.time}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/rechargenew/countdown/index.js